/* PDP V2 — hero polish + share buttons + subscription fallback.
 * Sticky add-to-cart, variant select, and form submit stay in the existing
 * main-product scripts. We just:
 *   1. Move the server-rendered flavor carousel into the hero image column
 *      so it sits directly below the main product image (Figma layout).
 *   2. Render a static "One-time purchase" pill if the recharge widget
 *      never injects its own (no plans / recharge missing).
 *   3. Wire the social share buttons.
 */
(function () {
  'use strict';

  // ---------- Flavor slider dots (Flickity) ----------
  // Base productthumbanil-slider init in theme.js disables pageDots, so we
  // render our own. Be resilient about how the Flickity instance is exposed:
  // - window.Flickity.data(el) on most builds
  // - element.flickity (jQuery plugin path)
  // - jQuery.data on $(el)
  function findFlickity(el) {
    try {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var inst = window.Flickity.data(el);
        if (inst) return inst;
      }
    } catch (e) {}
    if (el.flickity) return el.flickity;
    if (window.jQuery) {
      var data = window.jQuery(el).data('flickity');
      if (data) return data;
    }
    return null;
  }
  function initFlavorSliderDots() {
    var sliders = document.querySelectorAll('.productthumbanil-slider');
    sliders.forEach(function (el) {
      if (el.dataset.pdpDotsAdded === '1') return;
      var attempts = 0;
      var tryInit = function () {
        attempts++;
        if (!el.classList.contains('flickity-enabled')) {
          if (attempts < 50) setTimeout(tryInit, 200);
          return;
        }
        var inst = findFlickity(el);
        // Fall back to DOM-based dot rendering if we can't grab the
        // Flickity instance — clicking dots won't snap, but dots will
        // still render and reflect the selected cell visually.
        // Count cells directly via the markup class — Flickity moves
        // them into a .flickity-slider wrapper after init, but on some
        // re-init paths that wrapper isn't present, so the safer
        // selector is the cell class itself.
        var cells = el.querySelectorAll('.product-thumbnail-images_item');
        if (!cells.length) cells = el.querySelectorAll('.flickity-slider > *');
        if (!cells.length) cells = el.children;
        if (cells.length <= 1) return;

        var dotsHost = document.createElement('div');
        dotsHost.className = 'pdp-v2__flavor-dots';
        var initialIdx = inst ? inst.selectedIndex : 0;
        for (var i = 0; i < cells.length; i++) {
          var d = document.createElement('span');
          d.className = 'pdp-v2__flavor-dot' + (i === initialIdx ? ' is-active' : '');
          (function (idx) {
            d.addEventListener('click', function () {
              if (inst && typeof inst.select === 'function') inst.select(idx);
            });
          })(i);
          dotsHost.appendChild(d);
        }
        var wrapper = el.closest('.productthumbanil-section') || el.parentNode;
        wrapper.appendChild(dotsHost);

        if (inst && typeof inst.on === 'function') {
          inst.on('change', function (idx) {
            var ds = dotsHost.querySelectorAll('.pdp-v2__flavor-dot');
            ds.forEach(function (dEl, i) { dEl.classList.toggle('is-active', i === idx); });
          });
        }
        el.dataset.pdpDotsAdded = '1';
      };
      tryInit();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlavorSliderDots);
  } else {
    setTimeout(initFlavorSliderDots, 200);
  }

  // ---------- V2 Testimonials carousel (no autoscroll) ----------
  // The global testimonials JS auto-scrolls to slide 1 after 1s on load
  // and registers on data-section-type="testimonials". Our V2 section
  // uses data-section-type="pdp-v2-testimonials" to opt out of that JS,
  // and inits Flickity here with autoPlay: false so the slides sit
  // still on load and only advance when the user clicks the arrows.
  var v2TestimAttempts = 0;
  function initV2Testimonials() {
    var sliders = document.querySelectorAll('[data-pdp-v2-testimonials]');
    if (!sliders.length) return;
    // Flickity is bundled in theme.js but may not be on window yet
    // when this first runs. Retry up to ~6s before giving up so the
    // CSS fallback (slides visible without Flickity) takes over.
    if (typeof window.Flickity !== 'function') {
      if (v2TestimAttempts++ < 30) setTimeout(initV2Testimonials, 200);
      return;
    }
    sliders.forEach(function (slider) {
      if (slider.dataset.pdpV2TestimInit === '1') return;
      var count = parseInt(slider.dataset.count, 10) || slider.children.length;
      if (count <= 1) {
        slider.dataset.pdpV2TestimInit = '1';
        return;
      }
      try {
        // groupCells: false (one cell per page) so dots = number of
        // testimonials on every breakpoint. With explicit cell widths
        // pinned in CSS, prev/next still moves cell-by-cell, and dots
        // mirror the number of cells the user can navigate through.
        new window.Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          groupCells: false,
          adaptiveHeight: true,
          pageDots: true,
          prevNextButtons: true,
          autoPlay: false,
          wrapAround: false,
          draggable: true
        });
        slider.dataset.pdpV2TestimInit = '1';
        // a11y — Flickity's default aria-labels for the prev/next
        // buttons are "Previous"/"Next", which lose context outside
        // the carousel. Override with specific labels so screen-
        // reader users know what they're navigating.
        var prev = slider.querySelector('.flickity-prev-next-button.previous');
        var next = slider.querySelector('.flickity-prev-next-button.next');
        if (prev) prev.setAttribute('aria-label', 'Previous testimonial');
        if (next) next.setAttribute('aria-label', 'Next testimonial');
        // The page-dots Flickity emits are buttons without labels;
        // give each one an explicit "Go to testimonial N of N" so
        // screen readers announce position.
        var dots = slider.querySelectorAll('.flickity-page-dots .dot');
        var total = dots.length;
        dots.forEach(function (dot, i) {
          dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1) + ' of ' + total);
        });
      } catch (e) {
        /* Flickity not ready yet — retry once */
        setTimeout(initV2Testimonials, 300);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initV2Testimonials, 200); });
  } else {
    setTimeout(initV2Testimonials, 200);
  }

  // ---------- Stock label split (UPPERCASE prefix only) ----------
  // The base locale string is e.g. "In stock, ready to ship". We want
  // the part before the comma uppercase-styled and the part after in
  // its natural case. Wrap "In stock" in a span so CSS can target it.
  function splitStockLabel() {
    var nodes = document.querySelectorAll('.product-block--sales-point [data-product-inventory]');
    nodes.forEach(function (node) {
      if (node.dataset.pdpStockSplit === '1') return;
      var raw = node.textContent.trim();
      if (!raw) return;
      var commaIdx = raw.indexOf(',');
      if (commaIdx === -1) {
        // No comma (e.g. low-stock copy) — leave as-is
        node.dataset.pdpStockSplit = '1';
        return;
      }
      var prefix = raw.slice(0, commaIdx);
      var rest = raw.slice(commaIdx);
      node.innerHTML = '<span class="pdp-v2-stock-prefix">' + prefix + '</span>' + rest;
      node.dataset.pdpStockSplit = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitStockLabel);
  } else {
    splitStockLabel();
  }
  // Re-apply if the variant change re-renders the inventory text
  document.addEventListener('variantChange', function () {
    setTimeout(splitStockLabel, 50);
  });


  // ---------- Subscription options fallback ----------
  // The existing recharge integration in product-template.liquid builds
  // .custom-subscription-select / .custom-options inside #subscription-options
  // when window.recharge is available. We only render a static fallback
  // pill when:
  //   - 4 seconds have passed (recharge JS retries every 500ms)
  //   - AND recharge still hasn't built the dropdown
  //   - AND a MutationObserver continues watching in case recharge loads later
  function renderSubscriptionFallback() {
    var subOpts = document.getElementById('subscription-options');
    if (!subOpts) return;
    if (subOpts.querySelector('.custom-subscription-select')) return;

    var priceEl = document.querySelector('.product__price[data-product-price]')
      || document.querySelector('.product__price');
    var priceText = priceEl ? priceEl.textContent.trim().split(/\s+/)[0] : '';

    var pill = document.createElement('div');
    pill.className = 'custom-subscription-select pdp-v2-sub-fallback';
    pill.setAttribute('aria-disabled', 'true');
    pill.innerHTML =
      '<span class="label">One-time purchase</span>' +
      '<span class="full-price">' +
        (priceText ? '<span class="recharge-price">' + priceText + '</span>' : '') +
        ' (full price)' +
      '</span>';
    subOpts.appendChild(pill);

    var variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        setTimeout(function () {
          var p = document.querySelector('.product__price[data-product-price]')
            || document.querySelector('.product__price');
          var rp = pill.querySelector('.recharge-price');
          if (p && rp) rp.textContent = p.textContent.trim().split(/\s+/)[0];
        }, 50);
      });
    }
  }

  function watchSubscriptionOptions() {
    var subOpts = document.getElementById('subscription-options');
    if (!subOpts) return;

    // If the recharge widget is already there, do nothing.
    if (subOpts.querySelector('.custom-subscription-select:not(.pdp-v2-sub-fallback)')) return;

    // Observe so that when recharge eventually injects its widget, we
    // remove the fallback to avoid duplicates.
    var obs = new MutationObserver(function () {
      var real = subOpts.querySelector('.custom-subscription-select:not(.pdp-v2-sub-fallback)');
      if (real) {
        var fb = subOpts.querySelector('.pdp-v2-sub-fallback');
        if (fb) fb.remove();
        obs.disconnect();
      }
    });
    obs.observe(subOpts, { childList: true, subtree: true });

    // After 4s, if still empty, render the fallback.
    setTimeout(function () {
      if (!subOpts.querySelector('.custom-subscription-select')) {
        renderSubscriptionFallback();
      }
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchSubscriptionOptions);
  } else {
    watchSubscriptionOptions();
  }

  // ---------- Share buttons ----------
  var root = document.querySelector('.pdp-v2');
  if (!root) return;

  root.querySelectorAll('[data-pdp-share]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var platform = btn.getAttribute('data-pdp-share');
      var url = encodeURIComponent(window.location.href);
      var text = encodeURIComponent(document.title);
      var target;
      if (platform === 'facebook') {
        target = 'https://www.facebook.com/sharer/sharer.php?u=' + url;
      } else if (platform === 'twitter' || platform === 'x') {
        target = 'https://twitter.com/intent/tweet?url=' + url + '&text=' + text;
      } else if (platform === 'pinterest') {
        var img = document.querySelector('.product-images-gallery img, .pdp-v2 img');
        var media = img ? encodeURIComponent(img.src) : '';
        target = 'https://pinterest.com/pin/create/button/?url=' + url + '&media=' + media + '&description=' + text;
      }
      if (target) window.open(target, '_blank', 'noopener,width=600,height=600');
    });
  });
})();
